import { type FC } from 'react';
import {
  Export
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconExportProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconExport: FC<UiIconExportProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Export}
      {...props}
    />
  );
};
